import styled from 'styled-components';

export const SiteFooter = styled.footer`
  background-color: oklch(0.9842 0.0034 247.86);
  border-top: 1px solid oklch(0.9288 0.0126 255.51);
  padding: 40px 20px;
  margin-top: auto;
  width: 100%;
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const CopyrightText = styled.p`
  margin: 0 0 8px 0;
  color: oklch(0.2077 0.0398 265.75);
  font-size: 14px;
`;

export const FooterLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const FooterLink = styled.a`
  color: oklch(55.44% 0.041 257.42);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;

  &:hover {
    color: oklch(0.2077 0.0398 265.75);
  }
`;

export const CreditContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  font-size: 13px;
  color: oklch(0.7107 0.0351 256.79);
`;

export const CreditLink = styled.a`
  color: inherit;
  text-decoration: none;
  font-weight: 600;
  
  &:hover {
    text-decoration: underline;
  }
`;
